import React, { useEffect, useMemo, useState } from "react";
import { useSetRecoilState } from "recoil";
import {
  buyUpsell,
  finishUpsells,
  getUpsellsPrice,
  UpsellUid,
} from "../../../../api/Billing";
import upsellsAtom, { Upsell } from "../../../../atoms/UpsellsAtom";
import { UserAtom } from "../../../../atoms/UserAtom";
import { useModal } from "../../Modal";
import AutomationMagic from "./Upsells/AutomationMagic";
import ContentCreation from "./Upsells/ContentCreation";
import EmailPlayersListSwell from "./Upsells/EmailPlayersListSwell";
import SubscriptionBiz from "./Upsells/SubscriptionBiz";
import ThankYouPage from "./Upsells/ThankYouPage";

enum BuySelectorScreens {
  PREBUY,
  STRIPE,
  AutomationMagic,
  EmailPlayersListSwell,
  SubscriptionBiz,
  ContentCreation,
  ThankYouPage,
}

export default function BuySelectorModal(props: {
  isModal?: boolean;
  onFinish: () => void;
}) {
  const { isModal, onFinish } = props;
  const modal = useModal();
  // const setTDBar = useSetRecoilState(showTDBarAtom);
  const [currentScreen, setCurrentScreen] = useState<BuySelectorScreens>(
    BuySelectorScreens.AutomationMagic
  );
  const setBoughtUpsells = useSetRecoilState(upsellsAtom);
  const setUserInfo = useSetRecoilState(UserAtom);
  const [upsells, setUpsells] = useState<Upsell[]>();

  // const [, setLocation] = useLocation();

  useEffect(() => {
    (async () => {
      const upsellsRequest = await getUpsellsPrice();
      setUpsells(upsellsRequest);
    })();
  }, []);

  async function handleBuyUpsell(
    nextScreen: BuySelectorScreens | null,
    upsellUid: UpsellUid
  ) {
    try {
      const response = await buyUpsell({
        upsellUid,
      });
      if (response) {
        const upsell = upsells?.find((item) => item.uid === upsellUid);
        if (upsell) {
          setBoughtUpsells((old) => {
            if (old) return [...old, upsell];
            return [upsell];
          });
        }
        if (nextScreen) {
          setCurrentScreen(nextScreen);
        } else {
          setCurrentScreen(BuySelectorScreens.ThankYouPage);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  const screen = useMemo(() => {
    switch (currentScreen) {
      case BuySelectorScreens.AutomationMagic:
        return (
          <AutomationMagic
            onBuy={() =>
              handleBuyUpsell(
                BuySelectorScreens.EmailPlayersListSwell,
                UpsellUid.AutomationMagic
              )
            }
            onNoThanks={() =>
              setCurrentScreen(BuySelectorScreens.EmailPlayersListSwell)
            }
          />
        );
      case BuySelectorScreens.EmailPlayersListSwell:
        return (
          <EmailPlayersListSwell
            onBuy={() =>
              handleBuyUpsell(
                BuySelectorScreens.SubscriptionBiz,
                UpsellUid.EmailPlayersListSwell
              )
            }
            onNoThanks={() =>
              setCurrentScreen(BuySelectorScreens.SubscriptionBiz)
            }
          />
        );
      case BuySelectorScreens.SubscriptionBiz:
        return (
          <SubscriptionBiz
            onBuy={() =>
              handleBuyUpsell(
                BuySelectorScreens.ContentCreation,
                UpsellUid.SubscriptionBiz
              )
            }
            onNoThanks={() =>
              setCurrentScreen(BuySelectorScreens.ContentCreation)
            }
          />
        );
      case BuySelectorScreens.ContentCreation:
        return (
          <ContentCreation
            onBuy={() => {
              finishUpsells();
              handleBuyUpsell(
                BuySelectorScreens.ThankYouPage,
                UpsellUid.ContentCreation
              );
            }}
            onNoThanks={() => {
              finishUpsells();
              setCurrentScreen(BuySelectorScreens.ThankYouPage);
            }}
          />
        );
      case BuySelectorScreens.ThankYouPage:
        return (
          <ThankYouPage
            closeModal={() => {
              onFinish();
              modal.popModal();
            }}
          />
        );
      default:
        window.location.replace(window.location.href);
        return null;
    }
  }, [currentScreen, upsells]);

  return screen;
}
